import { InjectionToken } from '@angular/core';

import { MapDefaultOptions } from '../types';

export const DEFAULT_MAP_OPTIONS = new InjectionToken<MapDefaultOptions>('DEFAULT_MAP_OPTIONS');
